<template>
  <div class="content">
    <div class="header">
      <div
        v-for="(item,index) in labledata"
        :key="index"
        :class="{heightlight : lableindex==index}"
        @click="lableArea(index,item)"
      >
        {{item}}
        <div v-if="lableindex==index" class="xian"></div>
      </div>
    </div>
    <div v-if="taskdata.length>0">
      <div class="nav" v-for="(item,index) in taskdata" :key="index">
        <div class="navtop">
          <div>调训报送任务</div>
          <div style="font-size:16px">{{item.title}}</div>
          <div>截止时间：{{item.releasetime}}</div>
        </div>
        <div class="navmetter">
          <div>
            <div>单位：{{item.deptname}}</div>
            <div>警种：{{item.jzdicname}}</div>
          </div>
          <div>
            <div>时间：{{item.startime}} 至 {{item.endtime}}</div>
            <div>类型：{{item.catedicname}}</div>
          </div>
        </div>
        <div class="navfoot">
          <div>
            <div>
              <el-button type="primary" size="small" @click="continue1(item.id)">报送人员</el-button>
            </div>
            <div>
              <el-button type="primary" size="small" @click="btnSubmit(item.id)">下发任务</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else style="margin-top:20px">
      <nodata></nodata>
    </div>

    <div class="pagination">
      <el-pagination
        background
        prev-text="上一页"
        next-text="下一页"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="listQuery.Page"
        :page-size="listQuery.Limit"
        layout=" total,prev, pager, next,jumper"
        :total="listQuery.count"
        v-if="listQuery.count>0"
      ></el-pagination>
    </div>
    <el-dialog title="下发派送任务" :visible.sync="taskDialog" width="80%" center destroy-on-close>
      <DistributionTask ref="taskRef" v-if="taskDialog" :trainId="trainId"></DistributionTask>
      <span slot="footer" class="dialog-footer">
        <el-button @click="taskDialog = false">取 消</el-button>
        <el-button type="primary" @click="subUpdateTask">确 定</el-button>
      </span>
    </el-dialog>
    
    <el-dialog title="报送本单位人员" :visible.sync="onlineDialog" width="80%" center destroy-on-close>
      <TrainStaff ref="trainStaffRef" v-if="onlineDialog" :trainId="trainId"></TrainStaff>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onlineDialog = false">取 消</el-button>
        <!-- <el-button type="primary" @click="submitUpdate">确 定</el-button> -->
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as personcen from '@/api/personcenter/index.js';
import DistributionTask from '../../train/trainclass/compoents/distributionTask';
import TrainStaff from '../../train/trainclass/compoents/trainStaff';

export default {
  components: {
    DistributionTask,
    TrainStaff,
  },
  data() {
    return {
      currentPage2: 1,
      labledata: ['进行中', '未开始', '已逾期', '已完成'],
      lableindex: 0,
      taskdata: [],
      listQuery: {
        Page: 1,
        Limit: 5,
        count: 0,
      },
      taskDialog: false,
      onlineDialog: false,
      trainId: 0,
    };
  },
  created() {
    this.getlist();
  },
  methods: {
    //确认下发任务
    subUpdateTask() {
      this.$refs.taskRef.updateTask();
      this.taskDialog = false;
    },
    //下发报送任务
    btnSubmit(trainId) {
      this.trainId = trainId;
      this.taskDialog = true;
    },
    //确认人员
    submitUpdate() {
      this.$refs.trainStaffRef.updatePeople();
      this.onlineDialog = false;
    },
    //报送本单位人员
    continue1(trainId) {
      this.trainId = trainId;
      this.onlineDialog = true;
    },
    // getlist(){
    //     personcen.LoadActivityInfo(this.listQuery).then(res=>{

    //         this.taskdata=res.data
    //         res.data.forEach((element,index) => {
    //             let star=element.beginTime.slice(0,10)
    //             this.taskdata[index].beginTime=star
    //             let end=element.endTime.slice(0,10)
    //             this.taskdata[index].endTime=end
    //         });
    //         this.listQuery.count=res.count
    //     })
    // },
    getlist() {
      let para = {
        userId: this.$store.state.User.ids,
      };
      personcen.GetCenterTaskTrain(para).then((res) => {
        if (res.result == null) {
          this.taskdata = [];
        } else {
          this.taskdata = res.result;
        }
      });
    },
    lableArea(index, item) {
      this.lableindex = index;
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.listQuery.Limit = val;
    },
    handleCurrentChange(val) {
      this.listQuery.Page = val;
      this.getlist();
      // console.log(`当前页: ${val}`);
    },
    // btnSubmit(){
    //     this.$router.push({
    //         path:'/personCenter/scoreList',
    //         query:{
    //             id:91
    //         }
    //     })
    // },
    // continue1(id){
    //     this.$router.push({
    //         path:'/personCenter/continuetask',
    //         query:{
    //             id:id
    //         }
    //     })
    // }
  },
};
</script>

<style scoped>
.content {
  width: 900px;
  /* height: 1000px; */
  padding-bottom: 20px;
}
hr {
  margin: 1px;
  border-top: 1px solid #e2e3e6;
}
.heightlight {
  color: #409eff !important;
}
.header {
  width: 850px;
  height: 35px;
  border-bottom: solid 1px #ccc;
  padding-top: 10px;
  display: flex;
}
.header > div {
  width: 100px;
  text-align: center;
  line-height: 35px;
  font-size: 16px;
  cursor: pointer;
}
.header > div:hover {
  color: #409eff;
}
.xian {
  width: 90px;
  border: solid 1px #409eff;
  margin-left: 8px;
}
.nav {
  width: 800px;
  height: 190px;
  /* box-shadow: 2px 2px 5px rgba(215, 215, 215, 0.968627450980392); */
  border-radius: 10px;
  border: 1px solid #f2f2f2;
  margin: 0 auto;
  margin-top: 20px;
}
.navtop {
  height: 50px;
  display: flex;
  border-bottom: 1px solid #f2f2f2;
}
.navtop > div:nth-child(1) {
  width: 64px;
  text-align: center;
  height: 30px;
  line-height: 30px;
  margin-left: 20px;
  margin-top: 10px;
  background-color: rgb(248, 185, 10);
  border-radius: 5px;
  color: #fff;
}
.navtop > div:nth-child(2) {
  flex: 4;
  height: 30px;
  line-height: 30px;
  margin-top: 10px;
  font-weight: 700;
  font-size: 18px;
  margin-left: 20px;
}
.navtop > div:nth-child(3) {
  flex: 2;
  margin-top: 10px;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  color: #d90018;
}
.navmetter {
  height: 90px;
  border-bottom: 1px solid #f2f2f2;

  font-size: 16px;
}
.navmetter > div {
  display: flex;
}
.navmetter > div > div:nth-child(1) {
  flex: 2;
  margin-top: 15px;
  margin-left: 20px;
}
.navmetter > div > div:nth-child(2) {
  flex: 1;
  margin-top: 15px;
  margin-left: 20px;
}
.navfoot {
  height: 60px;
}
.navfoot > div {
  margin-top: 5px;
  display: flex;
  justify-content: flex-end;
}
.navfoot > div > div {
  width: 110px;
}
.pagination {
  margin-top: 20px;
  text-align: center;
}
</style>